<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{span:24}" :lg="{span:8}">
      <a-card :loading="loading">
        <div slot="title">
          <a-icon type="file-search" />&nbsp; Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <!-- <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    @change="searching"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div> -->
                <div class="m-form-item-wrapper">
                  <label for="thnsimulasiFilter">Year</label>
                  <a-select
                    placeholder="Ex: 2021 ... "
                    v-model="thnsimulasiFilter"
                    @change="searching"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in s_thnsimulasiFilter"
                      :key="item"
                      :value="item"
                    >{{item}}</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="statusAnggaranFilter">Status</label>
                  <a-select
                    placeholder="Ex: choose ... "
                    v-model="statusAnggaranFilter"
                    @change="searching"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in s_statusAnggaranFilter"
                      :key="item.key"
                      :value="item.key"
                    >{{item.label}}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{span:24}" :lg="{span:16}">
      <DataList
        :loading="loading"
        title="Finance Simulation"
        createLink="simulasianggaranCreateAcc"
        manifestLink="simulasianggaran.manifestAcc"
        editLink="simulasianggaranEditAcc"
        :tabbedSimulasiAnggaran="true"
        :dataList="dataListOutput"
        :draftList="draftListOutput"
        :rating="false"
      />
      <!-- :disabledCreateEditLink="bidangAccountManager" -->
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import Status from "@/components/Status.vue";
import Rating from "@/components/Rating.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListSimulasi",
  components: {
    Status,
    Rating,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      simulasiAnggaranList: [],
      draftList: [],
      storeList: [],
      search: "",
      searchDate: null,
      status: undefined,
      statusAnggaranFilter: "",
      s_statusAnggaranFilter:[],
      s_thnsimulasiFilter:[],
      thnsimulasiFilter:"",
      pagination: {
        pageSize: 5,
        size: "small",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getSalesType",
      "getStatus",
      "getDefaultDateFormat",
    ]),
    dataListOutput() {
      let output = [];

      this.simulasiAnggaranList.forEach((data) => {
        output.push({
          title: "Year "+ data.tahun,
          subtitle: data.nama,
          subdesc: [
                  {
                    label: "Saldo Awal",
                    value: this.formatRupiah(data.saldo_awal),
                  },
                  {
                    label: "Penerimaan Kas",
                    value: this.formatRupiah(data.penerimaan_kas),
                  },
                  {
                    label: "Pengeluaran Kas",
                    value: this.formatRupiah(data.pengeluaran_kas),
                  },
                  {
                    label: "Hutang",
                    value: this.formatRupiah(data.hutang),
                  },
                  {
                    label: "Saldo Sebelum Pendanaan",
                    value: this.formatRupiah(data.saldo_sebelum_pendanaan),
                  },
                  {
                    label: "Pendanaan",
                    value: this.formatRupiah(data.pendanaan),
                  },
                  {
                    label: "Saldo Sesudah Pendanaan",
                    value: this.formatRupiah(data.saldo_setelah_pendanaan),
                  },
                  {
                    label: "Hutang Tahun Berikutnya",
                    value: this.formatRupiah(data.hutang_tahun_berikutnya),
                  },
              ],
          status: data.aktif_sts=="1" ? "Aktif" : "Non Aktif",
          thn: data.tahun,
          id: data.id_simulasi,
        });
      });

      return output;
    },
    draftListOutput() {
      let output = [];

      this.draftList.forEach((data) => {
        output.push({
          title: "Year "+ data.tahun,
          subtitle: data.nama,
          subdesc: [
                  {
                    label: "Saldo Awal",
                    value: this.formatRupiah(data.saldo_awal),
                  },
                  {
                    label: "Penerimaan Kas",
                    value: this.formatRupiah(data.penerimaan_kas),
                  },
                  {
                    label: "Pengeluaran Kas",
                    value: this.formatRupiah(data.pengeluaran_kas),
                  },
                  {
                    label: "Hutang",
                    value: this.formatRupiah(data.hutang),
                  },
                  {
                    label: "Saldo Sebelum Pendanaan",
                    value: this.formatRupiah(data.saldo_sebelum_pendanaan),
                  },
                  {
                    label: "Pendanaan",
                    value: this.formatRupiah(data.pendanaan),
                  },
                  {
                    label: "Saldo Sesudah Pendanaan",
                    value: this.formatRupiah(data.saldo_setelah_pendanaan),
                  },
                  {
                    label: "Hutang Tahun Berikutnya",
                    value: this.formatRupiah(data.hutang_tahun_berikutnya),
                  },
              ],
          status: data.aktif_sts=="1" ? "Aktif" : "Non Aktif",
          thn: data.tahun,
          id: data.id_simulasi,
        });
      });

      return output;
    },
    searching() {
      let filteredDataBySearch = [];
      this.simulasiAnggaranList = this.storeList;

      if (this.search) {
        this.simulasiAnggaranList = this.simulasiAnggaranList.filter(
          (obj) =>
            obj.aktif_sts
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
             obj.tahun
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.catatan ? obj.catatan : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.nama ? obj.nama : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.statusAnggaranFilter) {
        console.log(this.statusAnggaranFilter);
        this.simulasiAnggaranList = this.simulasiAnggaranList.filter(
          (obj) =>
            obj.aktif_sts &&
            obj.aktif_sts.toLowerCase().indexOf(this.statusAnggaranFilter.toLowerCase()) >= 0
        );
      }

       if (this.thnsimulasiFilter) {
        console.log(this.thnsimulasiFilter);
        this.simulasiAnggaranList = this.simulasiAnggaranList.filter(
          (obj) =>
            obj.tahun &&
            obj.tahun.toLowerCase().indexOf(this.thnsimulasiFilter.toLowerCase()) >= 0
        );
      }

      if (!this.statusAnggaranFilter && !this.search && !this.thnsimulasiFilter) {
        this.simulasiAnggaranList = this.storeList;
      }
    },
    bidangAccountManager() {
      let returnVal = true;
      this.getAuth.nama_bidang.forEach((data) => {
        if (data === "Account Manager") {
          console.log(data);
          returnVal = false;
          return;
        }
      });
      return returnVal;
    },
  },
  methods: {
    moment,
    deleteListDraft(value){
      console.log(value);
      let postData = new FormData();
      postData.append("id_simulasi", value);
      axios({
          method: "post",
          url: this.$serviceUrl + "simulasi/delete",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.displayMessage("success-del");
            this.$router.go();
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
              this.displayMessageValue(
                "error-notif-kaskecil",
                response.data.message
              );
          });
    },
    fetchDataSimulasi() {
      const simulasi = axios({
        method: "get",
        url: this.$serviceUrl + "simulasi/list",
        params: {
          jenis: "non-draft",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const draft = axios({
        method: "get",
        url: this.$serviceUrl + "simulasi/list",
        params: {
          jenis: "draft",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          simulasi.catch((err) => {
            console.log(err)
            return null;
          }),
          draft.catch((err) => {
            console.log(err)
            return null;
          }),
        ])
        .then((response) => {
          console.log(response.data);
          this.simulasiAnggaranList = response[0].data.data;
          this.storeList = response[0].data.data;
          this.draftList = response[1].data.data;
          this.loading = false;

          this.s_thnsimulasiFilter = _.uniq(_.map(this.simulasiAnggaranList, 'tahun'));

           let tempsts = _.uniq(_.map(this.simulasiAnggaranList, 'aktif_sts'));
           tempsts.forEach((data) => {
             console.log(data);
             this.s_statusAnggaranFilter.push({
               key: data,
               label: data == "1" ? "Aktif" : "Non Aktif"
             })
           })
        })
        .catch((err) => {
          this.loading = false;
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
  mounted() {
    Event.$on("confirmMessageDelete", this.deleteListDraft);
    this.fetchDataSimulasi();

    const arrayUniqueByKey = [...new Map(this.simulasiAnggaranList.map(item =>
      [item['nm_anggaran'], item])).values()];

    console.log(arrayUniqueByKey);

    
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.deleteListDraft);
  }
};
</script>

<style>
</style>